<template>
  <div class="container">
    <div class="tabBox">
      <div :class="status == 1 ? 'active' : ''" @click.stop="typeClick(1)">
        发起愿景
      </div>
      <div :class="status == 2 ? 'active' : ''" @click.stop="typeClick(2)">
        活动流程
      </div>
      <div :class="status == 3 ? 'active' : ''" @click.stop="typeClick(3)">
        活动章程
      </div>
      <div :class="status == 4 ? 'active' : ''" @click.stop="typeClick(4)">
        常见问题
      </div>
    </div>
    <!-- 发起愿景 -->
    <div class="visionBox" v-if="status == 1">
      <div class="visionTitle">乘势而上，前方苍翠有光</div>
      <div class="exTitle">Ride On The Momentum And Take The Light</div>
      <div
        class="paragraphBox"
        v-for="(item, index) in visionList"
        :key="index"
      >
        <div>{{ item.cnContent }}</div>
        <div>{{ item.enContent }}</div>
      </div>
    </div>
    <!-- 活动流程 -->
    <div class="flowBox" v-if="status == 2">
      <div class="flowContent">
        <div class="flowTitle">开通报名通道 Application Launch</div>
        <div class="time">2022年10月 October, 2022</div>
        <div class="allContent">
          <div>
            2022年10月，开通网上报名及资料提交专门通道，参赛者进行资料准备及提交；工作人员进行资料初审，初审通过的申报项目即可在网上进行展示、宣传及配合推广。
          </div>
          <div>
            Since October 2022, the online registration and document submission
            has launched, through which competitors can prepare related document
            for submission; staff begin the document initial review and
            application passed the initial review will be exhibited and promoted
            online.
          </div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">申报及考察 Application and Recommendation</div>
        <div class="time">2022年10月-2023年4月, October, 2022-April, 2023</div>
        <div class="allContent">
          <div>
            在复审投票前，参评企业可以向组委会申请，邀约本届神灯奖提名委员和合作机构代表去进行申报项目考察。
          </div>
          <div>
            Previous to the secondary review voting, the participated
            enterprises can invite 2023 Alighting Award nominating committee and
            representatives from cooperative organizations through the
            committee.
          </div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">推荐截止 Deadline of Recommendation</div>
        <div class="time">2023年3月10日 10th March,2023</div>
        <div class="allContent">
          <div>2023年3月10日评审推荐截止。</div>
          <div>
            Late March 2023, review and voting will be implemented to all
            selected applicants .
          </div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">海选投票 Review</div>
        <div class="time">2023年3月底 Late March, 2023</div>
        <div class="allContent">
          <div>2023年3月底，将对所有当前阶段参评的项目进行投票评选</div>
          <div>
            Late March 2023, review and voting will be implemented to all
            selected applicants .
          </div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">路演汇报&复审会议 Roadshow Report</div>
        <div class="time">
          2023年3月底—2023年4月 Late March,2023--April,2023
        </div>
        <div class="allContent">
          <div>
            为了让评审团更深入了解参评项目的特点和优势，海选入围单位需参与路演汇报会，进行项目汇报，最终评选出优秀奖获奖项目
          </div>
          <div>
            In order to give the jury a deeper understanding of the
            characteristics and advantages of the participating projects, the
            listed units shall participate in the road report.
          </div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">
          公示优秀奖名单 Announced the Outstanding Items
        </div>
        <div class="time">2023年4月底 Late April, 2023</div>
        <div class="allContent">
          <div>
            组委会秘书处在阿拉丁照明网、神灯奖官网上公示优秀奖获奖名单，如有异议，在公示期内（7日）向主办方提出书面意见。
          </div>
          <div>
            The secretariat of the organizing committee will publicize the
            shortlisted of outstanding items on www.alighting.cn and
            sdj.alighting.cn. Any objection shall be submitted to the organizer
            with written comments within the publicity period (7 days)
          </div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">终审会议 Final Rediv</div>
        <div class="time">2023年5月底 Late May,2023</div>
        <div class="allContent">
          <div>
            根据入围优秀奖结果，第三方检测机构的检测报告以及实地考察意见，终审委员会召开闭门会议，投票评选出最佳获奖结果。
          </div>
          <div>
            Based on the results of the shortlisted of outstanding items, the
            testing report of the third-party testing agency and the field
            inspection, the final committee will hold a closed-door meeting to
            vote on the best results.
          </div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">颁奖典礼 The Award Ceremony</div>
        <div class="time">2023年6月9日 9th June, 2023</div>
        <div class="allContent">
          <div>广州国际照明展览会同期举办</div>
          <div>GILE will be held during the same period.</div>
        </div>
      </div>
      <div class="flowContent">
        <div class="flowTitle">后续推广 Promotion</div>
        <div class="time">2023年6月-11月 June-November, 2023</div>
      </div>
    </div>
    <!-- 活动章程 -->
    <div class="charterBox" v-if="status == 3">
      <div class="langTabBox">
        <div
          :class="langStatus == 1 ? 'active' : ''"
          @click.stop="typeLangClick(1)"
        >
          中文
        </div>
        <div
          :class="langStatus == 2 ? 'active' : ''"
          @click.stop="typeLangClick(2)"
        >
          ENGLISH
        </div>
      </div>
      <van-collapse
        v-if="langStatus == 1"
        v-model="activeNameAs"
        @change="onChange"
        :border="false"
      >
        <van-collapse-item title="一、总则" name="1" :border="false">
          <div class="pb_text">
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阿拉丁神灯奖”是在商务部指导下、广州市经济贸易委员会作为特别支持单位，由广州光亚法兰克福展览有限公司、广东光亚照明研究院于
              2013 年正式发起创办的具有国际影响力的行业奖项。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;关于"阿拉丁神灯奖"评选活动，从十一届开始，本奖项将制定新的章程，用以规范和明确相关的内容事项、操作流程和评审要求。
            </p>
            <p>
              1、评奖目的：为行业提供一个公开、公平、公正的展示平台，挖掘不为人知的先进事迹，树新风、展风采。
            </p>
            <p>1.1、 鼓励业界技术创新和产品创新，促进产业科技进步。</p>
            <p>
              1.2、 提升阿拉丁神灯奖的国内及国际影响力，促进行业的不断发展。
            </p>
            <p>
              1.3、
              树立优秀工程、优质产品、创新技术、创新设计的标杆和典范，倡导社会价值理念。
            </p>
            <p>2、"阿拉丁神灯奖"评选活动奖项设有：</p>
            <p>
              2.1、产品奖（照明产品、零配件、材料、设备，系统或技术解决方案等）
            </p>
            <p>
              2.2、设计奖（以光为重要手段或元素，进行各种形式的创作或概念设计）
            </p>
            <p>
              2.3、工程奖（已经竣工验收的照明工程项目&建筑智能化或智能家居设计方案）
            </p>
            <p>2.4、创新融合奖（与其他机构联合办奖）</p>
            <p>
              注：每个大类里面，将根据每年产品技术以及行业的发展现状，设置相应的若干个小分类。
            </p>
            <p>3、"阿拉丁神灯奖"评选时间：</p>
            <p>
              每年进行一次，根据【广州国际照明展览会】、【广州国际建筑电气技术及智能家居展览会】的举办时间，暂定为每年度9月~下一年度5月进行申报、推选、评审工作，每年6月展览会举办期间进行发布和颁奖典礼，每年6月~9月为当届阿拉丁神灯奖成果宣传期。
            </p>
            <p>4、"阿拉丁神灯奖"评选活动的申报对象及评选范围： </p>
            <p>
              4.1、产品奖申报对象：只要是合法经营的企业或个人，且申报项目具有自主知识产权均可申报。照明产品、零配件、材料、设备，系统或技术解决方案等具有前瞻性和发展性的，用于规划和引导产品研制和应用开发的技术理念及解决方案。
              产品奖：从技术创新性、实用性、经济性、文档服务四个方面进行。
            </p>
            <p>
              4.2、设计奖申报对象：凡年龄在18周岁以上的设计师、设计机构、高等院校设计专业师生、以及有相关设计实践的人士均可投稿参评。设计师运用光的颜色、亮度、温度等多重属性，契合声音、材料、情感等要素，与观者进行“交流”，表达自己的创意及想法。
              设计奖评审：从新颖和独创性、创新性、可行性与推广性三个方面进行。
            </p>
            <p>
              4.3、工程奖申报对象：具有独立法人资格的设计院（所）、设计公司，高等院校，科研单位和照明工程公司、该项目主要产品的供应商。如申报"工程奖"，需注意是指申报项目已完工，无权属争议并且是已竣工验收、投入使用在三个月以上的照明工程。
              工程评审：从功能适用、经济合理、安全可靠、技术先进、环境协调等五个方面评比。
            </p>
            <p>
              4.4、创新融合奖申报对象及评选范围：根据行业发展情况单独办奖，申报对象及评选范围根据奖项类型而定。
            </p>
            <p>5、"阿拉丁神灯奖"评选活动组织领导和实施机构：</p>
            <p>
              通过主办方、业内专家学者、权威人士、行业组织或机构组成的评审团审议和推荐，以科学、权威、客观、公正为原则，全面评价申报资料的先进性、独创性、实用性、完整性、经济性等评测因素，最终产生出阿拉丁神灯奖的评选结果。评审团按照评奖的类别，专门组成若干个专业评审组、专业考察组，具体承担和实施评审考察工作；投票工作以阿拉丁神灯奖组委会秘书处负责组织和实施。
            </p>
            <p>5.1、评审团：终审委员、所有专业评审组组成。 </p>
            <p>
              5.2、专业评审组：成员由主办方代表、神灯奖的合作机构代表和提名委员组成；专业考察组，则由其工作组部分成员随机组成。
            </p>
            <p>5.3、终审委员：由主办方代表、主办方特邀行业知名人士组成。 </p>
            <p>5.4、提名委员：主办方特邀行业知名人士组成。</p>
            <p>
              5.4.1、专家级：高级职称、本科+15年工作经历以上、硕士+10年工作经历以上，博士+5年工作经历以上；
            </p>
            <p>
              5.4.2、专业级：中级职称、本科+10年工作经历、硕士+5年工作经历以上，博士+3年工作经历以上
            </p>
            <p>5.5、合作机构：主办方特邀行业组织或机构。 </p>
            <p>5.6、组委会秘书处：承办单位和合作机构代表。</p>
            <p>6、“阿拉丁神灯奖”评选活动统筹、协调机构：</p>
            <p>
              "阿拉丁神灯奖"评选活动由专设的组委会秘书处统一协调、筹划、安排、落实具体的工作计划和实施方案，组委会秘书处由主办方代表，承办方代表（广州阿拉丁物联网络科技股份有限公司）组成。组委会秘书处作为"阿拉丁神灯奖"评选活动进行期间的协调班子和工作班子，负责解释、答复、接受有关评选活动的一切咨询、质疑和文档材料。
            </p>
             
          </div>
        </van-collapse-item>
        <van-collapse-item title="二、申报办法和要求" name="2" :border="false">
          <p class="pb_text">
            1、"阿拉丁神灯奖"评选活动采用由申报对象自主申报，或由合作机构、提名委员推荐具有创新特色和代表意义的项目参加评选，并在每年评选活动统一安排的规定时间内，将申报材料送交组委会秘书处汇总和审查，申报材料符合规定和要求的项目，由组委会秘书处交由评审团进行专业评审。
            2、凡申报过往届"阿拉丁神灯奖"评选活动的项目，如无明显改进或突出表现，主办方原则上不接受本年度的申报工作。
            3、申报时，应按照统一要求在阿拉丁神灯奖官方网站上进行网上或线下填报有关申报表格，尽量详尽提供以下材料。申报对象对所申报的材料应保证其内容规范、真实和清晰、明了。
            4、严禁申报过程中的任何弄虚作假行为，如查明属实的不真实申报单位，在评审阶段发现的取消申报资格；评审结束后发现并且属于获奖项目的，撤销获奖称号，并在行业内给予通报和公告。
            5、申报对象如对所申报的内容有保密要求，请在申报材料中明确标注。同时，所有接触申报材料的单位和人员，都必须严格按照有关要求对项目中的内容事项承担保密义务。
            6、所有申报"阿拉丁神灯奖"项目的申报材料不予退还。组委会秘书处将利用申报资料组织发行专刊或进行专题介绍。
            7、所有申报"阿拉丁神灯奖"的项目默认设计创意或知识产权属于申报单位或申报个人，如存在侵权行为均由申报方负责，主办方有权取消侵权作品的申报资格。
            <!-- <div class="table">
            <div>
              <div style="background-color: #a1a1a1;color: #fff;">序号</div>
              <div style="background-color: #a1a1a1;color: #fff;p-align: center;">类别</div>
              <div style="background-color: #a1a1a1;color: #fff;">产品类</div>
              <div style="background-color: #a1a1a1;color: #fff;">技术类</div>
              <div style="background-color: #a1a1a1;color: #fff;">工程类</div>
            </div>
            <div>
              <div>1</div>
              <div>申报项目的具体名称（中英文全称）</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>2</div>
              <div>申报项目的详细介绍</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>3</div>
              <div>申报项目的获奖记录</div>
              <div>如有</div>
              <div>如有</div>
              <div>如有</div>
            </div>
            <div>
              <div>4</div>
              <div>申报项目的相关图片</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>5</div>
              <div>申报项目申报单位的背景材料与申报项目相关证明</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>6</div>
              <div>申报项目的创新要点</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>7</div>
              <div>申报项目的应用情况</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>8</div>
              <div>申报项目的用户评价</div>
              <div>如有</div>
              <div>如有</div>
              <div>如有</div>
            </div>
            <div>
              <div>9</div>
              <div>申报项目的技术参数</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>10</div>
              <div>申报项目的有关专长及特征的其他证明材料</div>
              <div>是</div>
              <div>是</div>
              <div>否</div>
            </div>
            <div>
              <div>11</div>
              <div>申报项目的查新报告</div>
              <div>是</div>
              <div>否</div>
              <div>否</div>
            </div>
            <div>
              <div>12</div>
              <div>申报项目的质检报告</div>
              <div>是</div>
              <div>是</div>
              <div>是</div>
            </div>
            <div>
              <div>13</div>
              <div>申报项目获得国际、国内专利情况</div>
              <div>是</div>
              <div>否</div>
              <div>否</div>
            </div>
            <div>
              <div>14</div>
              <div style="width: 622rpx;border-right: 1px solid #ddd;">
                <div>“工程”类申报对象需要提供以下资料：</div>
                <div>1、工程竣工验收报告；</div>
                <div>2、工程质量评估报告；</div>
                <div>3、反映工程全貌及关键部位质量的彩色照片8张以上，或者工程全貌及工程质量的视频（时间约3~5分钟）；要求图像清晰，构图完整、可观性强，能反映工程特点及科技含量和质量水平。</div>

                <div>“创新融合奖”申报对象需根据奖项设置要求提供相关资料。</div>
              </div>
            </div>
          </div> -->
          </p>
        </van-collapse-item>
        <van-collapse-item title="三、评审程序" name="3" :border="false">
          <p class="pb_text">
            "阿拉丁神灯奖"评选活动的评审基本分为初审、路演&考察、复审和终审四个阶段。
            1、初审阶段：主要由专设的组委会秘书处根据申报对象送交的申报表格和申报材料，在申报类别当中，分别确定若干项作为候选的项目。
            2、路演&考察阶段：已经获得海选入围资格的申报项目，秘书处将组织若干个专业评审小组进行路演或线下实地考察，并根据实际情况予以评价。
            3、复审阶段：每一个小分类专业评审小组成员根据路演&考察评价，以及海选投票结果，结合评审标准，举行复审会议并进行投票，确认优秀奖结果。组委会秘书处负责汇总各类别结果，将优秀奖的结果进行公示，如公示期内如无异议，提交终审委员会。
            4、终审阶段：主要是评审团终审委员会，根据专业评审工作组的入围结果、评审意见和推荐建议，确定最后阿拉丁神灯奖该类别的最佳奖获得者，由组委会秘书处向社会各界进行统一发布和推荐介绍。
            注：考察阶段主要是由候选项目的申报对象，在评审前，向主办方申请邀约专业考察组进行申报项目的考察及点评，讲解其申报项目的有关情况；考察结束后，专业考察组将向组委会秘书处提供已考察申报对象的考察报告，并用作评审的评选参考建议。
            公示阶段：经复审评选后，秘书处将获奖项目的详细情况向社会公示，自发布之日起，七天内为异议期。如有异议，需在异议期内向终审委员会（由秘书处提交终审委员会审议）提出书面意见和理由，并附上相关证明材料；过期视为无异议。
          </p>
        </van-collapse-item>
        <van-collapse-item title="四、发布和奖励办法" name="4" :border="false">
          <p class="pb_text">
            1、"阿拉丁神灯奖"评选活动的最终评选结果在每年一度的【广州国际照明展览会】、【广州国际建筑电气技术及智能家居展览会】举办期间进行发布和颁奖典礼，所有获奖的项目都将获得"阿拉丁神灯奖"主办单位所颁发的奖杯或获奖证书。
            2、阿拉丁神灯奖组委会秘书处在全部评审工作结束后，负责编辑出版《"阿拉丁神灯奖"年鉴》，该汇编作为"阿拉丁神灯奖"评选活动获奖项目及其他申报项目的权威和正式发布形式之一，发布、宣传、推广获奖项目以及评审专家的评价分析。
          </p>
        </van-collapse-item>
        <van-collapse-item title="五、附则" name="5" :border="false">
          <p class="pb_text">
            1、"阿拉丁神灯奖"评选活动主办单位为广州光亚法兰克福展览有限公司、广东光亚照明研究院，承办单位为广州阿拉丁物联网络科技股份有限公司。
            2、本章程由阿拉丁神灯奖组委会秘书处制定、修改并负责解释。
            3、本章程自公布之日起实施。
          </p>
        </van-collapse-item>
      </van-collapse>
      <van-collapse
        v-if="langStatus == 2"
        v-model="activeNameBs"
        @change="onBChange"
        :border="false"
      >
        <van-collapse-item
          title="I. General Provisions"
          name="1"
          :border="false"
        >
          <div class="pb_p">
            <p>
              Alighting Award is an industry award with international influence
              officially launched by Guangzhou Guangya Frankfurt Exhibition Co.,
              Ltd and Guangdong Guangya Lighting Research Institute in 2013
              under the guidance of the Ministry of Commerce and the special
              support of Guangzhou Economic and Trade Commission.
            </p>
            <p>
              Starting from the 11th Alighting Award selection, new regulations
              will be formulated in order to standardize and specify relevant
              matters, operational processes and selection requirements.
            </p>
            <p>
              1. Objectives: To provide an open, fair and impartial exhibition
              platform for lighting, dig out unknown lighting deeds,foster new
              trends and show the lighting industry.
            </p>
            <p>
              1.1 To encourage technological and product innovation in the
              lighting industry and promote scientific and technological
              progress in lighting.
            </p>
            <p>
              1.2 To enhance the international influence of the Alighting Award
              and promote the continuous development of the lighting industry.
            </p>
            <p>
              1.3 To set up an example and model for outstanding projects, high
              quality products, innovative technologies and innovative designs,
              and advocate the concept of social value.
            </p>
            <p>
              2.The awards included in the Alighting Award selection are as
              follows:
            </p>
            <p>2.1 Product Award:(Lighting products, non-component)</p>
            <p>
              2.2 Technology Award: (Lighting components, materials, equipment,
              systems or technological solutions, etc., non-lighting products)
            </p>
            <p>2.3 Project Award: (For completed lighting projects)</p>
            <p>
              2.4 Innovation Award (cooperated with other institutions) Notes:
              According to the development of product technologies and the
              industrial trend, each Award category above will be divided into
              multiple sub-categories.
            </p>
            <p>
              3. Schedule of the Alighting Award selection: The selection is
              held annually. In accordance with the time when Guangzhou
              International Lighting Exhibition is held, it has been tentatively
              decided that the application, recommendation and rediv are carried
              out from September to May of the next year. The selection results
              shall be announced and the award ceremony shall be held in June
              when Guangzhou International Lighting Exhibition is held. And the
              award-winners of the Alighting Award will be publicized from June
              to September.
            </p>
            <p>
              4.Applicants participating in the Alighting Award selection and
              theselection scope:
            </p>
            <p>
              4.1 Product Award applicants: Legally operating enterprise or
              individual and the declared product with independent intellectual
              property right can apply. "Products" generally refer to the
              lighting products that have been mass-produced and non-component.
              The product selection is conducted in terms of technological
              innovativeness, practicability, economy and document service.
              Technological innovativeness: Whether the technical indicators of
              a product have met the latest standards at home and abroad and
              what innovative features it has will be assessed. For example, do
              the major parts of the product have the latest and most popular
              configuration Have the main technical parameters and the nominal
              indicators met the latest industry standards Has the product
              received any award Is the product patented Has the product
              undergone any significant technical improvement, technological
              innovation, design innovation or other innovations Practicability:
              The practical value of a product and its humanized factors in its
              application will be assessed. For example, in terms of humanized
              design (Is it easy to install and operate How is the workmanship
              and quality Is the electromagnetic circuit safe Has the product
              design met the design specifications), what are the users’
              comments How is the compatibility of the product Does the product
              support various standards Is it easy to maintain in use Economy:
              The price/performance ratio, use cost and maintenance cost of the
              product and its expandability will be assessed. Document service:
              The quality and efficiency of the instruction book and technical
              manuals of a product as well as the level of service provided by
              the manufacturer will be assessed. (Are the documents illustrated
              and easy to understand Is there specific description of all
              functions and components of the product Is there any instruction
              on the repair Is there any detailed guidance on the installation,
              disassembly and operation How is the product warranty)
            </p>
            <p>
              4.2 Technology Award applicants: Legally operating enterprise or
              individual and the declared product with independent intellectual
              property right can apply. "Technologies" generally refer to
              lighting components, materials, equipment, systems or
              forward-looking and developmental technical ideas or solutions for
              planning and guiding product development and application. The
              technological selection is conducted in terms of technological
              innovativeness, practicability and economy. Technological
              innovativeness: The innovative key points and features of a
              technology will be assessed. For example, has the technology
              received any award Is the technology patented In terms of the
              innovative key points in technology, is the new technology
              significant, practical and effective In terms of the innovative
              key points in design, can the design be directly applied to real
              products How are the design feature and originality if it is
              applied to the products How are the innovative key points in other
              aspects Is the technology forward-looking Will it become a leading
              standard Will it be the mainstream Does it have an application
              prospect Practicability: What will be assessed are the practical
              value and promotion potential of the technology, for example, the
              independence and feasibility of the technology and whether there
              is any case in practical application. Economy: How much economic
              benefit the technology can produce will be assessed. For example,
              how much cost (the human resources and material resources invested
              to realize the technology) is needed to realize the technology How
              much is the return on investment (How long may it take to recoup
              the investment)
            </p>
            <p>
              4.3 Project Award applicants: Design institutes or companies with
              independent legal qualifications, colleges and universities,
              scientific research institutions, lighting engineering companies
              and suppliers of major products of the project. "Projects" refer
              to the lighting projects having been completed with no ownership
              dispute and having been put into use for more than three months.
              The project selection is conducted in terms of technological
              innovativeness, implementation effect, energy saving, security and
              durability. Technological innovativeness: Whether the technical
              indicators of all the components of the project have met the
              latest domestic and overseas standards and the innovative features
              it has will be assessed. For example, do the major products of the
              project have the latest and most popular configuration Have the
              main technical parameters and the nominal indicators met the
              latest industry standards Do the components have innovative points
              in technology, design or other aspects Implementation effect:
              Respect for design and carrier (conforming to the carrier's
              property and expressing the relationship between different carrier
              elements), visual aesthetics (artistic and creative), visual
              comfort (with reasonable contrast ratio and no glare while
              coordinating with the surroundings), consistency between the
              reality and the design effect. Energy saving: The use cost and
              maintenance cost of the project will be assessed. For example,
              does the project use highly efficient lighting products Does it
              apply hierarchical control of the effects Has it met the latest
              national design standards How much maintenance cost (cost of human
              resources, material resources and electricity) is needed for the
              project in service Security: The stability (stability and
              reliability of system operation), capability of accidental
              emergency management, restorability of the project and whether it
              can minimize losses will be assessed. For example, are the
              installation and maintenance convenient What are the safety
              precautions for the facilities What are the safety precautions for
              the operation with power on Durability: How long is the service
              life of the materials for the project How long can more than 80%
              of the materials be in service without being replaced
            </p>
            <p>
              4.4 Innovation Award object of declaration and scope of
              evaluation: The award shall be awarded separately according to the
              development of industry, and the object of declaration and scope
              of evaluation shall be determined according to the type of award.
              5.Organizational leadership and implementing bodies of the
              Alighting Award selection The Alighting Award selection results
              will be achieved through deliberations and recommendations by the
              Jury Committee consisting of the sponsor, experts and scholars in
              the industry, authorities, industry organizations or institutions,
              following the principles of science, authority, objectiveness and
              fairness and comprehensively evaluating the submitted materials
              from aspects of the advancement, originality, practicability,
              completeness and economy. According to the categories of awards,
              namely product, technology, project and design, the Jury Committee
              specially sets up several Professional Evaluation Teams and
              Professional Investigation Teams, responsible for the evaluation
              and investigation; the Secretariat of the organizing committee of
              the Alighting Award is responsible for the organization and
              implementation of the voting.
            </p>
            <p>
              5.1 Jury Committee:Consisting of final judges and all professional
              jury teams.
            </p>
            <p>
              5.2 Professional Evaluation Team : Including representatives of
              the sponsor and the cooperative institutions for the Alighting
              Award as well as the nominating committee members; Professional
              Investigation Team are randomly composed of some members of their
              respective teams.
            </p>
            <p>
              5.3 Final Judges: Including representatives of the sponsor and the
              industry celebrities specially invited by the sponsor.
            </p>
            <p>
              5.4 Nominating Committee Members: Elected from the winners of the
              last Alighting Award or composed of industry celebrities specially
              invited by the sponsor.
            </p>
            <p>
              5.4.1 Experts: Senior title, Bachelor +15 years working experience
              above, Master +10 years working experience,Doctor +5 years working
              experience;
            </p>
            <p>
              5.4.2 Specialists: Intermediate title, Bachelor +10 years working
              experience above, Master +5 years working experience, Doctor +3
              years working experience;
            </p>
            <p>
              5.5 Cooperative Institutions: the industry organizations or
              institutions specially invited by the sponsor.
            </p>
            <p>
              5.6 Secretariat of the organizing committee: Representatives of
              organizers and cooperative institutions.
            </p>
            <p>
              6. Planning and coordination body of the Alighting Award
              selection: The specially established secretariat of the organizing
              committee is responsible for the coordination,
              planning,arrangement and implementation of specific working plan
              and implementation schemes for the Alighting Award selection. The
              secretariat of the organizing committee consists of
              representatives of the organizing committee of Guangzhou
              International Lighting Exhibition, representatives of organizers
              (Guangzhou Alighting IOT & Technology, Co., Ltd). As the
              coordination and working team during the Alighting Award
              selection, the secretariat of the organizing committee is
              responsible for accepting all the consultations, queries and
              document materials relating to the appraisal and selection and
              providing explanations and replies.
            </p>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="II.Application Measures and Requirements"
          name="2"
          :border="false"
        >
          <div class="pb_p">
            <p>
              1. Applicants can independently apply for participation in the
              Alighting Award selection or the entities whose items have
              innovative features and typicality are recommended by the
              cooperative institutions and nominating committee members to
              participate in the selection. Application materials shall be
              submitted to the secretariat of the organizing committee for
              collection and examination within the stipulated time for each
              year's appraisal and selection. The secretariat of the organizing
              committee will submit those items with application materials
              conforming to regulations and requirements to the Jury Committee
              for professional appraisal.
            </p>

            <p>
              2. In principle, the sponsor will not accept the applications of
              projects which had applied for participation in the selection of
              the previous Alighting Award and have not made obvious
              improvements or have no outstanding performance.
            </p>

            <p>
              3. For application, relevant application forms shall be filled in
              and submitted online at www.alighting.cn or offline according to
              the requirements. The following materials shall be provided and
              shall be as detailed as possible. Applicants should make sure the
              application materials are standardized, true and clear in content.
            </p>
            <!-- <div class="table">
              <div>
                <div style="background-color: #a1a1a1; color: #fff">No.</div>
                <div style="background-color: #a1a1a1; color: #fff">
                  Category
                </div>
                <div style="background-color: #a1a1a1; color: #fff">
                  Product
                </div>
                <div style="background-color: #a1a1a1; color: #fff">
                  Technology
                </div>
                <div style="background-color: #a1a1a1; color: #fff">
                  Project
                </div>
              </div>
              <div>
                <div>1</div>
                <div>
                  Exact name of the submitted project (full names in both
                  Chinese and English)
                </div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>2</div>
                <div>Detailed introduction to the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>3</div>
                <div>Award winning records of the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>4</div>
                <div>Related pictures of the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>5</div>
                <div>
                  Background materials of the unit submitting the project and
                  relevant certifications for the submitted project
                </div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>6</div>
                <div>Innovative points of the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>7</div>
                <div>Application status of the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>8</div>
                <div>User feedback for the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>9</div>
                <div>Technical parameters of the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>10</div>
                <div>
                  Other certification materials of relevant specialties and
                  characteristics of the submitted project
                </div>
                <div>Yes</div>
                <div>Yes</div>
                <div>No</div>
              </div>
              <div>
                <div>11</div>
                <div>Novelty search report of the submitted project</div>
                <div>Yes</div>
                <div>No</div>
                <div>No</div>
              </div>
              <div>
                <div>12</div>
                <div>Quality inspection report of the submitted project</div>
                <div>Yes</div>
                <div>Yes</div>
                <div>Yes</div>
              </div>
              <div>
                <div>13</div>
                <div>
                  International and domestic patent obtainment status of the
                  submitted project
                </div>
                <div>Yes</div>
                <div>No</div>
                <div>No</div>
              </div>
              <div>
                <div>14</div>
                <div style="width: 622rpx; border-right: 1px solid #ddd">
                  The applicants applying for Project Award need to provide the
                  following materials: 1. Project completion and acceptance
                  report; 2. Project quality assessment report; 3. More than 8
                  color photographs reflecting the full div and quality of key
                  parts of the project or a video of the project's full div and
                  quality (about 3 to 5 minutes), with clear image, complete
                  composition and high observability, able to reflect the
                  project's characteristics, technological content and quality.
                  The applicants applying for Innovation Award should provide
                  relevant information according to the requirements of the
                  award setting.
                </div>
              </div>
            </div> -->

            <div>
              4. Any trickery is strictly prohibited during the application
              process. Application units will be disqualified for application if
              they are found to be unreal in the selection stage. If an
              application unit wins an award but is then discovered to be
              unreal, the award and title will be canceled, which will be
              notified and announced in the industry.
            </div>

            <div>
              5. If applicants have confidentiality requirements for the
              submitted content, please clearly describe the requirements in the
              submitted materials. Meanwhile, all units and persons having
              access to the submitted materials must undertake the obligation of
              confidentiality for the content and matters of the projects
              strictly in accordance with the relevant requirements.
            </div>

            <div>
              6. All materials submitted for the Alighting Award selection will
              not be returned. The secretariat of the organizing committee will
              make use of the submitted materials to release special issues or
              make introductions to special topics.
            </div>
            <div>
              7.All projects applying for the Alighting Award have the design
              creativity or intellectual property rights belonging to the
              applying enterprise or individual, if there is any infringement
              occurs, the applicant shall be responsible for it and the
              organizer has the right to cancel the application qualification of
              infringing works.
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="III. Selection Procedures"
          name="3"
          :border="false"
        >
          <div class="pb_p">
            <p>
              1. Initial rediv: Based on the application forms and materials
              submitted by the applicants, the specially established secretariat
              of the organizing committee will choose some projects as the
              candidate ones for the four categories respectively.
            </p>
            <p>
              2. Rediv: After receiving all the candidate projects sorted out by
              the secretariat of the organizing committee (including the
              inspection opinions of the Professional Inspection Teams), all
              members of the Professional Evaluation Team will confirm the vote
              of each application category within a designated time in
              accordance with the rediv criteria. The secretariat of the
              organizing committee is responsible for collecting the voting
              results of each category and publicizing the results of
              Outstanding Products, Outstanding Technologies, Outstanding
              Projects and Outstanding Innovation. If no objection received
              within the public notice period, the results will be submitted to
              the final appeal board.
            </p>
            <p>
              3. Inspection: In order to provide corresponding test data
              analysis for the final part, the applicants of the candidate
              projects will be sent to the designated test agency for data
              detection and analysis of the third party. 4. Final rediv:
              According to the Professional Evaluation Team's appraisal opinions
              and recommendations on the entries, final judges of the Jury
              Committee will decide winners of the Alighting Award, namely Best
              Product, Best Technology, Best Project and Best Innovation, which
              will be announced and introduced to the all sectors of society by
              the secretariat of the organizing committee. Notes: In the
              inspection stage, the applicants of the candidate projects will
              apply to the sponsor for inviting the Professional Inspection
              Teams to inspect and comment the submitted projects and listen to
              the applicants' description of relevant conditions of the
              submitted projects before the inspection; after the inspection,
              the Professional Inspection Teams will submit the inspection
              reports of the inspected objects to the secretariat of the
              organizing committee as reference for the rediv. Publicity stage:
              After the evaluation, the detailed information of the award
              winners will be published for public rediv by the secretariat for
              seven days from the date of publication as the objection period.
              In case of any objection, written opinions and reasons shall be
              submitted to the Final Judge Committee (submitted by the
              secretariat to the Final Judge Committee) within the objection
              period, together with relevant supporting documents; Expiration is
              deemed to be without objection.
            </p>
            <p>
              4.Final review: According to the Professional Evaluation Team's
              appraisal opinions and recommendations on the entries, final
              judges of the Jury Committee will decide winners of the Alighting
              Award, namely Best Product, Best Technology, Best Project and Best
              Innovation, which will be announced and introduced to the all
              sectors of society by the secretariat of the organizing committee.
            </p>
            <p>
              Notes: In the inspection stage, the applicants of the candidate
              projects will apply to the sponsor for inviting the Professional
              Inspection Teams to inspect and comment the submitted projects and
              listen to the applicants' description of relevant conditions of
              the submitted projects before the inspection; after the
              inspection, the Professional Inspection Teams will submit the
              inspection reports of the inspected objects to the secretariat of
              the organizing committee as reference for the review.
            </p>
            <p>
              Publicity stage: After the evaluation, the detailed information of
              the award winners will be published for public review by the
              secretariat for seven days from the date of publication as the
              objection period. In case of any objection, written opinions and
              reasons shall be submitted to the Final Judge Committee (submitted
              by the secretariat to the Final Judge Committee) within the
              objection period, together with relevant supporting documents;
              Expiration is deemed to be without objection.
            </p>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="IV. Announcement and Award-giving Measures"
          name="4"
          :border="false"
        >
          <div class="pb_p">
            <p>
              1. The final results of the Alighting Award selection will be
              announced and the award ceremony will be held during Guangzhou
              International Lighting Exhibition which is held annually. All the
              winners will receive the trophy cups and honor certificates given
              by the sponsor of the Alighting Award.
            </p>
            <p>
              2. After all the selection work is completed, the secretariat of
              the organizing committee of the Alighting Award will be
              responsible for editing and publishing the Alighting Award
              Yearbook. As one of the authoritative and official forms of
              issuing the winning projects and other submitted projects in the
              Alighting Award selection, the collection will be used to publish,
              publicize and popularize the winning projects as well as the
              selection experts' assessment and analysis.
            </p>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="V. Supplementary Provisions"
          name="5"
          :border="false"
        >
          <div class="pb_p">
            <p>
              1. The Alighting Award selection is initiated by Guangzhou
              International Lighting Exhibition, sponsored by Guangzhou Guangya
              Messe Frankfurt Co., Ltd. and organized by Guangzhou Alighting
              IOT&Technology Co.,Ltd.
            </p>
            <p>
              2. The regulation is formulated and amended by the secretariat of
              the organizing committee of the Alighting Award which is
              responsible for the explanation.
            </p>
            <p>
              3. The regulation takes effect as of the date of promulgation.
            </p>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <!-- 常见问题 -->
    <div class="charterBox" v-if="status == 4">
      <van-collapse v-model="activeNameCs" @change="onCChange" :border="false">
        <van-collapse-item
          title="怎样才能参加“阿拉丁神灯奖”？"
          name="1"
          :border="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                首先通过奖项设置了解自己所申报的项目所属的类别，再点击右上角“申报登录”即可开始提交申报材料参与评选。（若曾为光亚展展商会员或曾参与过神灯奖的用户可用原注册账号登录，否则请注册新账号，若忘记原账号密码或有任何疑问的请联系秘书处工作人员。）
              </div>
              <div>
                产品奖申报对象：只要是合法经营的企业或个人，且申报项目具有自主知识产权均可申报。
              </div>
              <div>
                设计奖申报对象：凡年龄在18周岁以上的设计师、设计机构、高等院校设计专业师生、以及有相关设计实践的人士均可投稿参评。
              </div>
              <div>
                工程奖申报对象：具有独立法人资格的设计院（所）、设计公司，高等院校，科研单位和照明工程公司、该项目主要产品的供应商。
              </div>
              <div>
                创新融合奖的申报对象——根据行业发展情况单独办奖，对象根据奖项类型而定。
              </div>
              <div>注意：企业或个人申报项目总数不能超过6个。</div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="我刚去填写了些报名申报资料，但上面有些内容不知道怎么填写，能否指导下？"
          name="2"
          :border="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox" style="display: flex; flex-basis: auto">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              请拨打咨询热线020-38477489/18902263629，秘书处将有专人为您解答并提供范本供您参考。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="我刚在阿拉丁神灯奖专题提交了产品申报资料，但提交后没有任何回复，是不是说明我提交的资料不符合要求吗？"
          name="3"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              由于申报材料较多，秘书处需1-3个工作日进行资料审核工作，您可以在3个工作日后再去查看结果；若提交资料未通过审核，秘书处会有专人与您联系，提醒您去修改完善。若资料审核通过将会在阿拉丁神灯奖官网申报情况栏目展示。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="申报项目中有的项目有显示推荐标志，这个推荐人该怎么找，一定要有推荐人吗？"
          name="4"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                项目申报分为"评审团（提名委员或合作机构）推荐申报”和”自主申报”两种。这个推荐人不做限制，但我们还是鼓励申报产品有推荐人，这样将便于评审团对于该产品的评审。
              </div>
              <div>
                建议一：申报单位可以从我们的评审团（提名委员或合作机构）成员中寻找熟悉的推荐人，并自主与其联系。如果您的申报项目得到评审团成员的青睐，秘书处收到他们提交的推荐信即会在对应项目中添加推荐标志。
              </div>
              <div>
                建议二：申报单位可以向秘书处申请邀约评审团成员组成考察团，前往项目考察。如果您的申报项目得到考察团成员的青睐，秘书处收到他们提交的推荐信即会在对应项目中添加推荐标志。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="每家企业可以参与几个项目评奖？"
          name="5"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              只要符合申报条件，所有类别都可以参与申报。但是注意企业或个人的申报项目总数不能超过6个（企业类评选除外）；申报同一小分类的项目，不能为同一名称的不同款式。不建议同一小分类申报过多项目，以致投票结果过于分散，降低获奖几率。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="每家单位最多不能申报超过6个项目，我先前提交的6个项目都已审核通过，但现在想换另一个项目申报，可以修改吗？"
          name="6"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              可以。不过需要替换掉原成功申报的项目中的某一项，通知秘书处取消（审核不通过）其中一项；然后，再重新提交新申请的另一个项目，重新走资料审核流程。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="申报审核通过后具体会有怎样的宣传方式宣传申报项目？"
          name="7"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>a,神灯奖网站上公示所有通过审核的申报项目；</div>
              <div>b,《阿拉丁设计》杂志：选取部分获奖项目资料刊登杂志；</div>
              <div>c,阿拉丁微信：选取部分获奖项目资料进行宣传；</div>
              <div>
                d,行业其它媒体（近60家）：软文将转给各支持媒体进行同期报道。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="如果企业想邀请评委去考察他们工厂，是什么阶段去？需要具备怎么样的条件才能申请评委考察工厂"
          name="8"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                只要申报材料通过审核，时间在投票前（2023.4.15以前），都可以进行企业或项目实地考察！考察分为两种形式：
              </div>
              <div>
                1、企业直接邀请2023阿拉丁神灯奖评审团成员（神灯奖网站上有公布名单）前去考察。
              </div>
              <div>
                2、如通过秘书处邀请评委，必须在申报材料通过审核之后进行。秘书处根据实际情况，向评审团部分成员发出考察通知，并根据实际情况安排考察计划。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="阿拉丁神灯奖最终会评多少个项目获奖？"
          name="9"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              神灯奖申报类别分为若干个小分类，由每个类别下申报数量决定最终获奖数量，优秀奖比例为申报数量的0~20%；最佳奖的获奖比例为优秀奖的0～40%
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="若只是获得优秀奖，我们将得到什么奖励，只是发个证书吗？"
          name="10"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              获得优秀奖的单位，除了会获得优秀奖证书之外，会在我们的阿拉丁神灯奖官网和《阿拉丁·设计》杂志以及《阿拉丁神灯奖年鉴》、视频宣传上都有详细的报道，并在全球规模最大的广州国际照明展览会期间公示给全体观众；此外，我们对所有获奖的资料进行整合，并开展全行业和相关领域的宣传推广活动，同时进行下一年的评选推广活动。另外，我们将组织优秀奖颁奖活动，对入围的优秀奖项目给予颁奖。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="最佳奖获奖单位可以获得的服务内容是什么？"
          name="11"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                1、全球规模最大的广州国际照明展览会（光亚展）现场的视频宣传；
              </div>
              <div>
                2、五万份精美画册《阿拉丁神灯奖年鉴》宣传；（在光亚展期间以及阿拉丁神灯奖系列推广活动现场派发）；
              </div>
              <div>3、阿拉丁神灯奖官网宣传，《阿拉丁.设计》特版宣传；</div>
              <div>
                4、有机会获得获奖单位或人物专访，并在60家合作机构媒体发布；
              </div>
              <div>5、下一年神灯奖活动推广资料上，宣传最佳奖获得者；</div>
              <div>6、宣传软文将转给各支持媒体进行同期报道；</div>
              <div>7、群发20万份邮件宣传最佳获得者；</div>
              <div>8、有机会担任下一届神灯奖的提名委员。</div>
            </div>
          </div>
          <!-- <div class="table">
            <div class="one">
              <div
                style="
                  width: 102px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                *申报单位名称
              </div>
              <div style="width: 253px">
                <div>*中文：</div>
                <div style="border-bottom: none">*英文：</div>
              </div>
            </div>
            <div class="one">
              <div style="width: 103px">*联系人</div>
              <div style="width: 75px"></div>
              <div style="width: 103px">*手机</div>
              <div style="width: 75px"></div>
            </div>
            <div class="one">
              <div style="width: 103px">*邮箱</div>
              <div style="width: 75px"></div>
              <div style="width: 103px">*固话</div>
              <div style="width: 75px"></div>
            </div>
            <div class="one">
              <div style="width: 103px">*通讯地址</div>
              <div style="width: 253px"></div>
            </div>
            <div class="one">
              <div style="width: 103px">*申报类别</div>
              <div style="width: 253px">□产品类（只限灯具产品） □ 技术类</div>
            </div>
            <div class="one">
              <div style="width: 103px">*申报单位介绍</div>
              <div style="width: 253px"></div>
            </div>
            <div class="one">
              <div style="width: 103px">推荐单位</div>
              <div style="width: 253px">提名委员： 合作机构：</div>
            </div>
          </div>
          <div style="font-size: 12px; margin-top: 15px">项目情况</div>
          <div class="tableB">
            <div class="one">
              <p
                style="
                  width: 153px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                项目名称
              </p>
              <div style="width: 203px">
                <div>中文：</div>
                <div style="border-bottom: none">英文：</div>
              </div>
            </div>
            <div class="one">
              <p style="width: 153px">*完成时间</p>
              <p style="width: 25px"></p>
              <p style="width: 153px">*进入市场时间</p>
              <p style="width: 25px"></p>
            </div>
            <div class="one">
              <p style="width: 153px">*综合介绍（或申报理由）</p>
              <p style="width: 203px">（200字以内））</p>
            </div>
            <div class="one">
              <p style="width: 153px">*相关产品图片</p>
              <p style="width: 203px">
                产品正面图、侧面图、尺寸图、使用效果图、安装示意图；配光曲线图
              </p>
            </div>
            <div class="one">
              <p style="width: 153px">*主要技术参数</p>
              <p style="width: 203px"></p>
            </div>
            <div class="one">
              <p style="width: 153px">*技术及工艺创新要点</p>
              <p style="width: 203px"></p>
            </div>
            <div class="one">
              <p style="width: 153px">与国内外同类产品或同类技术的比较情况</p>
              <p style="width: 203px"></p>
            </div>
            <div class="one">
              <p style="width: 153px">
                实际运用案例和用户评价意见（如有图，附图说明）
              </p>
              <p style="width: 203px"></p>
            </div>
            <div class="one">
              <p style="width: 153px">获奖、专利情况（如有图，附图说明）</p>
              <p style="width: 203px">
                技术评价（鉴定文件）、知识产权证明（专利证书）、项目获奖证书
              </p>
            </div>
            <div class="one">
              <p style="width: 153px">经济评价分析</p>
              <p style="width: 203px"></p>
            </div>
          </div> -->
        </van-collapse-item>
        <van-collapse-item
          title="神灯奖获奖企业，宣传服务时间起止点是如何界定的？"
          name="12"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="content">
              从展会期间开始，大部分宣传项目服务截止时间到次年的3月31日。但神灯奖网站上将永久保存。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="申报工程项目获奖涉及到设计公司、工程公司和多家灯具提供商，如何进行颁奖和颁发证书？"
          name="13"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              若工程项目获奖，领奖者原则将是谁申报谁获奖；若是多家单位联合申报将均可得到证书。如果是工程项目的产品单位申报，必须提供该项目作为主要供应商的凭证。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="设计奖需要哪些必要资料？"
          name="14"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                设计奖的不同类别所需资料不尽相同，关于灯具、装置设计需提供不局限于设计软件的手绘稿、3D效果图、PhotoShop效果图等，配合文字说明，表达设计理念。
              </div>
              <div>
                室内外光环境设计则需提供项目设计的平面图、灯位图、效果图等，作品可以体现灯具类型，不需体现具体产品品牌及型号。若为已完工项目，则需提供亮灯效果实景图。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="章程中所需资料众多，有哪些是必要的？一定要专利证书吗？"
          name="15"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="content">
              在各类申报表格中，只要是有红色*号，均属于必填项目。但为避免获奖项目存在侵权嫌疑，专利证书或者专利号是荣获产品奖和设计奖优秀奖的重要条件。所有申报项目默认设计创意或知识产权属于申报单位或申报个人，如存在侵权行为均由申报方负责，主办方有权取消侵权作品的申报资格。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="为什么要填写这么多资料？很多资料都不能公开，你们会怎么处理？"
          name="16"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="cotent">
              项目资料越详细，越便于后期评审团充分了解申报项目，从而作出更客观的判断。同时，详尽的资料既是为了验证申报项目的真实性，也是保证知识产权不受侵害的主要手段。但对于较为隐私性的资料，可在申报阶段提交保密文件，也可向组委秘书处提出申请，我们将不会公示。申报过程中填写的个人信息亦不会公开，公示的内容只会提取部分申报资料。
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="神灯奖如何评？谁来评？"
          name="17"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                1、每一个小类别都组建专业评审组（约20-30位），设置专业评审组主任一位，副主任一至两位。每位评审团成员可同时担任几个小分类的评委（不超过十个小类），在该类别分别拥有5张选票。评审团成员采取规避原则，即所在单位如果参与某一小分类申报，则自动取消该类别的投票资格。
              </div>
              <div>
                2、神灯奖申报类别分为若干个小分类，由每个类别下申报数量决定最终获奖数量，优秀奖比例为申报数量的0~20%；最佳奖的获奖比例为优秀奖的0～40%
                。当某类别申报不足的情况下，由该小类别专业评审组进行来讨论相应的解决办法，如取消该类别的优秀提名奖。每一个大类别的突出奖项，不需要进行特别申报，终审委员会将从所有小类优秀提名奖里面，特别进行评分，从而评选完成。
              </div>
              <div>
                3、第十一届阿拉丁神灯奖的评审规则分为初审、海选、优秀奖评选和最佳奖评选四个阶段。其中，在优秀奖评选活动中，由评审团代表对海选结果排名前50%且参与当场活动的项目进行现场汇报宣讲，再由现场专业评委和大众评委进行现场投票，从而产生优秀奖获奖名单，并进行全网公示，公示期无异议者，将参加最佳奖竞选。最后由终审委员综合各项材料选出最佳奖获奖项目。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="是否不要费用？不给钱是不是获不了奖？"
          name="18"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>1、奖项申报不收取任何费用！</div>
              <div>
                2、奖项评选经阿拉丁神灯奖评审团海选投票+线下优秀奖竞选投票结果产生。
              </div>
              <div>
                3、只要申报项目优秀，并按要求参加所有的竞选环节，即可脱颖而出，获取荣誉。
              </div>
              <div>
                4、所以，获奖的关键申报的产品、工程、设计项目要足够优秀、经典、创新。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="参与线下优秀奖评选活动有什么好处？能否不参加？"
          name="19"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                强烈建议参加！参与线下优秀奖评选活动将获得以下权益，如果企业不参与线下优秀奖评选则视为放弃优秀奖竞选资格。
              </div>
              <div>参与线下优秀奖评选活动能获得以下权益：</div>
              <div>
                ①活动现场的交流机会（参会人员包括行业专家评委、工程单位、设计单位、生产单位等）
              </div>
              <div>②优秀奖的竞选机会（与会人员方可加入到优秀奖的角逐行列）</div>
              <div>
                ③入围项目的PPT展示机会（与会人员需提前提供组委会秘书处3-5p的PPT资料，由参会的专家评委针对资料在现场进行项目的简单汇报演讲）
              </div>
              <div>
                ④现场大众评审投票资格（与会人员均作为大众评委，与现场专家评委共同投票选出优秀奖获奖项目）
              </div>
              <div>
                ⑤获得海选入围证书（与会人员无论最终是否获得优秀奖，均可获得入围证书）
              </div>

              <div>
                Ps：若企业想在活动现场进行实物展示需缴纳2万费用（不限于申报单位）
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="4次海选投票+公开评审活动是线上大众投票吗？活动在哪里举办？"
          name="20"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                1、4次海选投票是由组委会组织评审团成员进行线上投票，而非大众投票。票选在前50%的项目即可受邀参与公开的评审活动。优秀奖评选活动则是由活动现场的评委老师和观众共同票选，最终得出优秀奖获奖项目。
              </div>
              <div>
                2、四场活动将在四个城市举办，分别在华南（12月、4月）、华中（2月）、华北（3月）三大区域各择一城市举行优秀奖评选活动，预计首场活动举办城市为广州，参赛者可根据自己所在区域就近选择参赛时间。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="受邀参加优秀奖评选活动，但因客观原因无法出席怎么办？"
          name="21"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                1、原则上建议受邀单位尽量参与当场活动，若确因客观原因无法出席，可联系主办方行使复活赛权力，参与下一赛区的活动。但若下一赛区仍不能出席，则视为放弃优秀奖竞选资格。
              </div>
              <div>
                2、参与优秀奖竞选但终未获得优秀的项目，可有一次且仅此一次选择下一赛区优秀奖评选活动的机会，且必须提供新的更详尽的资料，若第二次角逐仍未能获奖，则不可再参与评选。
              </div>
            </div>
          </div>
        </van-collapse-item>
        <van-collapse-item
          title="海选未能入围可以付费参与优秀奖评选活动吗？"
          name="22"
          :boder="false"
        >
          <div slot="icon">
            <p class="iconfont icon-tiwen" style="color: #000733"></p>
          </div>
          <div class="contentBox">
            <p class="iconfont icon-huida" style="color: #3e69af"></p>
            <div class="pb_p">
              <div>
                1、海选未能入围的参赛者无需付费也可参与优秀奖评选活动，但不能以申报单位身份参与评选，不过只要到场的观众均拥有现场大众评审投票的资格。
              </div>
              <div>
                2、参与优秀奖评选活动无需费用，若与会人员有意在活动现场进行品宣则需缴纳费用。
              </div>
              <div>
                3、若申报项目未在海选投票中票选前50%，可有一次且仅有一次机会，能参与下一轮次的海选投票，但若下一轮次仍未能票选在前50%则该项目不能再参与海选。但可选择新的项目申报。
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>

    <!-- <div class="right-box">
      <div @click.stop="toPathHandle">
        <img src="../../../static/images/lighting/declare.png" />
      </div>
    </div> -->
  </div>
</template>
<script>
import { Collapse, CollapseItem } from "vant";
export default {
  name: "about",
  components: {
    "van-collapse": Collapse,
    "van-collapse-item": CollapseItem,
  },
  data() {
    return {
      status: 1,
      visionList: [
        {
          cnContent:
            "历史的航程波澜壮阔，时代的大潮奔腾不息。阿拉丁神灯奖至今连续举办九届，已成为备受业界关注的极具影响力奖项。",
          enContent:
            "The voyage of history is magnificent and the tide of the times is surging. Alighting Award has been held for nine consecutive times and has become a highly influential award which attracts the attention of the industry.",
        },
        {
          cnContent:
            "2021年第九届阿拉丁神灯奖共收到来自791家单位及211名个人提交的2,283项申请，与上一届相比增长11.3%；经过来自9个国家及地区的192位提名委员和36家合作机构成员投票、复核，共选出220个获奖项目。此外，本届评选设置智能照明百强企业榜，引领照明企业在智能领域的健康化发展。",
          enContent:
            "In 2021, the 9th Alighting Award received 2,283 applications from 791 units and 211 individuals which is an increase of 11.3% compared with the previous time. After voted and reviewed by 195 nominating committee members from 11 countries and regions and 36 members of cooperative institutions, a total of 219 projects were awarded. In addition, we also set up a list of top 100 intelligent lighting enterprises this time in order to lead a healthy development of lighting enterprises in the field of intelligence.",
        },
        {
          cnContent:
            "2021年，这是疫情之后产业发展的里程碑。新征程，重新定义新发展，也重塑着我们的生活，这一年注定将留下极其特殊而重要的印记。阴霾散去，万物复苏。这一年，阿拉丁神灯奖在不断突破与创新，新发展格局、新技术、新产品、新业态、新模式……新征程上，更加精彩的赛道，在无数照明人心中点亮希望之光，激荡起“后浪”奔腾的澎湃动力。可以说，阿拉丁神灯奖表彰的精神，正是当下行业最需要的标杆。",
          enContent:
            "The year of 2021 is a milestone in industrial development after the epidemic. This new journey redefines new development and reshapes our lives which are destined to leave a very special and important mark for us in this year. The haze is gone and everything is revived. In this year, Alighting Award has made continuous breakthroughs and innovations, new development patterns, new technologies, new products, new formats, new models and so on. The light of hope in the hearts of countless lighting people has be lit up with the new journey and more wonderful track and stirred up the surging power of 'back waves1'. It can be said that the spirit of Alighting Award is the benchmark that the industry needs most.",
        },
        {
          cnContent:
            "阿拉丁神灯奖的发展，既是为了把握产业前行中的发展规律，更是为了增强产业开拓前进中的勇气和力量，更以其创新锐变进而演化为积极的参与者，在更高起点、更高层次、更高目标上推进产业的创新和未来。",
          enContent:
            "The development of Alighting Award is not only to grasp the development law of the industry, but also to enhance the courage and strength of the industry and to become a positive participant with innovation in order to proceed the industry at a higher starting point, at a higher level and with a higher goal.",
        },
        {
          cnContent:
            "2021年，我们站在一个历史新起点上。阿拉丁神灯奖，正在集聚着光芒与力量。前路之上，于领先者，必有百尺竿头、更进一步的机遇；于落后者，必有弯道超车、后来居上的机遇；于所有参与者，必有从无到有、开创新局的机遇。历史不会终结，因为新的历史正在书写——",
          enContent:
            "In 2021, we stand at a new historical starting point. Alighting Award is gathering light and strength, on the road ahead, for leaders, there will be further opportunities; if you fall behind, you will have the opportunities to overtake and catch up; for all participants, there must be opportunities to start a new business from scratch. History will not end because new history is being written.",
        },
        {
          cnContent: "再出发，我们的征途是星辰大海；",
          enContent: "Let's start again and our journey is the sea of stars;",
        },
        {
          cnContent: "推开世界的门，前方苍翠有光！",
          enContent:
            "Open the door of the world, there is light in front of it!",
        },
      ],

      langStatus: 1,
      activeNameAs: ["1"],
      activeNameBs: ["1"],
      activeNameCs: ["1"],
    };
  },
  methods: {
    toPathHandle() {
      window.location.href =
        "https://www.alighting.cn/webapp/award/declare.htm?t=1";
    },

    //大的tab切换操作
    typeClick(n) {
      this.status = n;
    },

    //活动章程语言切换
    typeLangClick(n) {
      this.langStatus = n;
    },
    onChange(event) {
      this.activeNameAs = event;
    },

    onBChange(event) {
      this.activeNameBs = event;
    },

    onCChange(event) {
      this.activeNameCs = event;
    },
  },

  mounted() {
    if (!this.Common._isMobile()) {
      window.location.href = "https://sdj.alighting.com/about.html";
    }
  },
};
</script>
<style scoped src="../../../static/css/about.css">
</style>